/* ll-pdp.js — owner: product builder. Loaded (defer) on product templates by snippets/ll-head.liquid.
   Small helpers for the ll-pdp-* sections only. It never touches the buy box, the Skio picker, gifts, the sticky bar or
   the cart: those keep their own live scripts.
   - [data-ll-pdp-dialog="<id>"] opens <dialog id="<id>">; [data-ll-pdp-close] closes the dialog it sits in.
   - [data-ll-pdp-tobuy] scrolls back to the buy box (main-product-v2 / .pdpv2), falling back to the link's href. */
(function () {
  'use strict';
  if (window.__llPdp) return;
  window.__llPdp = true;

  /* "Shop Now" lands where the buying happens (QA 2026-10-08 D5): the first purchase control (kids count, plan cards, the live
     variant pickers, the bundle's kids row), not the top of the gallery; the sticky header's height is left clear above it */
  function buyBox() {
    return document.querySelector('.pdpv2bb .bbv2-kids, .pdpv2bb .bbv2-plans, .pdpv2 .pdpv2__variants, .bts-page .bts-kids, .bts-page .bts-plans') ||
      document.querySelector('main-product-v2.pdpv2, .pdpv2, .bts-page');
  }
  function headerOffset() {
    var h = document.querySelector('.ll-sec--header, .shopify-section-group-header-group');
    return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
  }
  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-ll-pdp-dialog], [data-ll-pdp-close], [data-ll-pdp-tobuy]') : null;
    if (!t) return;

    if (t.hasAttribute('data-ll-pdp-dialog')) {
      var d = document.getElementById(t.getAttribute('data-ll-pdp-dialog'));
      if (d && typeof d.showModal === 'function') {
        e.preventDefault();
        d.showModal();
      }
      return;
    }
    if (t.hasAttribute('data-ll-pdp-close')) {
      var open = t.closest('dialog');
      if (open && open.open) open.close();
    }
    if (t.hasAttribute('data-ll-pdp-tobuy')) {
      var box = buyBox();
      if (box) {
        e.preventDefault();
        var top = box.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: reduced() ? 'auto' : 'smooth' });
      }
    }
  });


  /* ---------- 10-13 template (html.ll-pdp--v3): tiles under the outcome line; compare-table Shop Now stays on the page ---------- */
  if (document.documentElement.classList.contains('ll-pdp--v3')) {
    /* C1 hero order is pure CSS now (order + display: contents in ll-pdp.css): no script move, so no layout shift. */
    /* R10 ingredient cards (design review 10-13): split each card's one paragraph at its line break so the benefit can lead */
    if (document.documentElement.classList.contains('ll-chg-ingr')) {
      document.querySelectorAll('.pdp-ingredients-redesign__card-text p').forEach(function (p) {
        if (p.querySelector('.ll-ingr-ben')) return;
        var parts = p.innerHTML.split(/<br\s*\/?>/i);
        if (parts.length !== 2) return;
        var a = /benefit/i.test(parts[0]) ? 1 : 0;
        p.innerHTML = '<span class="ll-ingr-ben">' + parts[1 - a].trim() + '</span><span class="ll-ingr-src">' + parts[a].trim() + '</span>';
      });
      /* short benefit lines (Brad 10-14: "way too wordy"; Sol round 11, cmo picks). Theme-only: the product data stays as is.
         '' = no approved benefit wording, so the card shows the ingredient and its source only. */
      var llBen = { 'vitamin a': 'Supports immune function*', 'vitamin c': 'Supports immune health*', 'vitamin d3': 'Supports bone and immune health*',
        'vitamin k2 (mk-7)': 'Supports healthy bones*', 'thiamine (vitamin b1)': 'Supports energy metabolism*', 'riboflavin (vitamin b2)': 'Supports energy production*',
        'niacin (vitamin b3)': 'Helps the body use energy*', 'pantothenic acid (vitamin b5)': 'Helps turn food into energy*', 'vitamin b6': 'Supports the immune system*',
        'vitamin e': 'Supports antioxidant activity*', 'folate': 'Supports cell growth*', 'vitamin b12 (as methylcobalamin)': 'Supports red blood cell formation*', 'biotin': 'Supports skin, hair and nails*' };
      document.querySelectorAll('.pdp-ingredients-redesign__card').forEach(function (c) {
        var t = c.querySelector('.pdp-ingredients-redesign__card-title'), b = c.querySelector('.ll-ingr-ben');
        if (!t || !b) return;
        var k = t.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
        if (!(k in llBen)) return;
        if (llBen[k]) b.textContent = llBen[k]; else { b.remove(); c.classList.add('ll-ingr--nobenefit'); }
      });
    }
    document.querySelectorAll('.difference-table__button').forEach(function (a) { a.setAttribute('data-ll-pdp-tobuy', ''); });
    /* R11 award photo first (html.ll-chg-award): the band's inline step (sections/ll-pdp-band.liquid, llAwardFirst) moves the
       award slide to the front while the page parses, so it paints first. This is the safety net once parsing is done: it
       finishes any list the parse-time step missed and always shows the gallery. If the gallery script already started, it
       re-reads the slide, thumb and dot lists so swipes, thumbs and dots follow the new order. */
    if (document.documentElement.classList.contains('ll-chg-award')) {
      var gal = document.querySelector('[data-pdpv2-gallery]');
      if (typeof window.llAwardFirst === 'function') window.llAwardFirst(true);
      else if (gal && !gal.hasAttribute('data-ll-award')) gal.setAttribute('data-ll-award', 'none');
      var mp = gal && gal.closest('main-product-v2');
      if (mp && mp.slides && gal.getAttribute('data-ll-award') === 'done') {
        mp.slides = mp.querySelectorAll('[data-pdpv2-slide]');
        mp.thumbBtns = mp.querySelectorAll('[data-pdpv2-thumb-btn]');
        mp.dots = mp.querySelectorAll('[data-pdpv2-dot]');
      }
    }
  }
  /* Keep the approved Kids Multi award hero first when a flavour swap rebuilds the gallery.
     The shared component emits this synchronously after rebuilding its images and controls.
     Reset only the award helper's parse-time caches, then refresh the component's node lists.
     This is theme-only; each product's catalog media order stays unchanged. */
  document.addEventListener('pdpv2:product-changed', function (event) {
    if (!document.documentElement.classList.contains('ll-chg-award') ||
        typeof window.llAwardFirst !== 'function') return;
    var mp = event.target;
    if (!mp || !mp.matches || !mp.matches('main-product-v2')) return;
    var gal = mp.querySelector('[data-pdpv2-gallery]');
    if (!gal) return;
    gal.removeAttribute('data-ll-award');
    delete gal.__llAt;
    ['[data-pdpv2-thumbs]', '[data-pdpv2-hero-track]', '[data-pdpv2-dots]', '[data-pdpv2-thumbs-mobile]'].forEach(function (selector) {
      var list = gal.querySelector(selector);
      if (list) delete list.__llDone;
    });
    window.llAwardFirst(true);
    mp.slides = mp.querySelectorAll('[data-pdpv2-slide]');
    mp.thumbBtns = mp.querySelectorAll('[data-pdpv2-thumb-btn]');
    mp.dots = mp.querySelectorAll('[data-pdpv2-dot]');
  });

  /* ---------- the band follows the flavour ---------- */
  var band = document.querySelector('.ll-pdp-band[data-ll-family]');
  var flavorsEl = document.querySelector('[data-ll-band-flavors]');
  var flavors = null;
  try { flavors = flavorsEl ? JSON.parse(flavorsEl.textContent) : null; } catch (err) { flavors = null; }
  if (band && flavors) {
    var family = band.getAttribute('data-ll-family');
    var keyFor = function (text) {
      var t = String(text || '').toLowerCase();
      if (/cherry/.test(t) && flavors[family + '_cherry']) return family + '_cherry';
      if (/peach|mango/.test(t) && flavors[family + '_peach']) return family + '_peach';
      if (/strawberr|mixed|berry/.test(t) && flavors[family]) return family;
      return null;
    };
    var apply = function (key) {
      var f = key && flavors[key];
      if (!f || band.getAttribute('data-ll-band') === key) return;
      band.setAttribute('style', f.style);
      band.setAttribute('data-fa', f.fa);
      band.setAttribute('data-fb', f.fb);
      band.setAttribute('data-tint', f.tint);
      band.setAttribute('data-ll-band', key);
      /* painted layer: every layer stays painted; the new one goes on top and fades in, so nothing flickers */
      var layers = band.querySelectorAll('.ll-pdp-pb-l');
      for (var i = 0; i < layers.length; i++) layers[i].classList.toggle('is-on', layers[i].getAttribute('data-k') === key);
    };
    var activeFlavor = function () {
      var el = document.querySelector('[data-pdpv2-option-value="flavor"]') ||
        document.querySelector('.pdpv2__chip--active .pdpv2__chip-label, .pdpv2__chip[aria-pressed="true"] .pdpv2__chip-label');
      return el ? el.textContent : '';
    };
    var fromPage = function () {
      var k = keyFor(activeFlavor()) || keyFor(location.pathname);
      if (k) apply(k);
    };
    var settle = function () { [60, 400, 1200].forEach(function (ms) { setTimeout(fromPage, ms); }); };
    /* a flavour chip: its own label is the new flavour (capture phase, so the swap has not started yet) */
    document.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('.pdpv2__chip') : null;
      if (!chip) return;
      var label = chip.querySelector('.pdpv2__chip-label');
      var k = keyFor(label ? label.textContent : chip.textContent);
      if (k) apply(k);
      settle();
    }, true);
    /* any history change (the in-place swap, back / forward): re-read the page */
    ['pushState', 'replaceState'].forEach(function (m) {
      var orig = history[m];
      if (typeof orig !== 'function') return;
      history[m] = function () { var r = orig.apply(this, arguments); settle(); return r; };
    });
    window.addEventListener('popstate', settle);
    window.addEventListener('pageshow', fromPage);
    fromPage();
  }

  /* ---------- "More real nutrition" tabs (ll-pdp-shop): ARIA tabs, roving tabindex, arrows / Home / End (homepage behaviour) ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ll-pdp-tabs]'), function (tl) {
    if (tl.__ll) return; tl.__ll = 1;
    var tabs = Array.prototype.slice.call(tl.querySelectorAll('[role="tab"]'));
    var cur = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    function select(t, focus) {
      if (t !== cur) {
        tabs.forEach(function (x) {
          var on = x === t, p = document.getElementById(x.getAttribute('aria-controls'));
          x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; if (p) p.hidden = !on;
        });
        cur = t;
        if (tl.scrollWidth > tl.clientWidth) tl.scrollLeft = Math.max(0, t.offsetLeft - (tl.clientWidth - t.offsetWidth) / 2);
      }
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
        else if (k === 'ArrowLeft' || k === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (k === 'Home') n = tabs[0];
        else if (k === 'End') n = tabs[tabs.length - 1];
        if (!n) return;
        e.preventDefault(); select(n, true);
      });
    });
  });

  /* ---------- the refund line in the guarantee (Brad 2026-10-08: "Swap out line 2 text for the refund language.") ----------
     Text comes from the theme setting ll_refund_line (Theme settings > Llama Land: brand numbers), carried on the band as
     data-ll-refund; blank leaves the live line 2. The buy box Liquid stays untouched: on Buy Box v2 and the bundle page this
     replaces the text of the guarantee's line 2 (same node, same style, so screen readers read the new line only). Kids Sleep
     gets its card from snippets/ll-pdp-guarantee.liquid; the line under the trust bar is only a fallback without it. Re-runs if the buy box re-renders. */
  var refundSrc = document.querySelector('.ll-pdp-band[data-ll-refund]');
  var refund = refundSrc ? refundSrc.getAttribute('data-ll-refund').trim() : '';
  if (refund) {
    var addRefund = function () {
      document.querySelectorAll('.bbv2-guarantee > div, .bts-guarantee__body').forEach(function (body) {
        var sub = body.querySelector('.bbv2-g-sub, .bts-guarantee__sub');
        if (!sub) {
          sub = document.createElement('div');
          sub.className = body.classList.contains('bts-guarantee__body') ? 'bts-guarantee__sub' : 'bbv2-g-sub ff-primary';
          body.appendChild(sub);
        }
        if (sub.textContent !== refund) sub.textContent = refund;
      });
      document.querySelectorAll('.pdpv2__trust-bar').forEach(function (bar) {
        if (bar.closest('.pdpv2bb') || !bar.querySelector('.icon-shield')) return;
        var card = bar.parentElement.querySelector('.ll-pdp-guar');
        if (card && getComputedStyle(card).display !== 'none') return;
        var next = bar.nextElementSibling;
        if (next && next.classList.contains('ll-pdp-refund')) return;
        var line = document.createElement('div');
        line.className = 'll-pdp-refund ff-primary';
        line.textContent = refund;
        bar.insertAdjacentElement('afterend', line);
      });
    };
    addRefund();
    var mainEl = document.getElementById('MainContent') || document.querySelector('main');
    if (mainEl && window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return; queued = true;
        requestAnimationFrame(function () { queued = false; addRefund(); });
      }).observe(mainEl, { childList: true, subtree: true });
    }
  }

  /* ---------- one guarantee, not two (bundle template) ----------
     Where the guarantee card shows (snippets/ll-pdp-guarantee.liquid), the Skio plan picker's benefit list repeats it as a
     "Money-Back Guarantee" row. The list lives in the picker's shadow root (no CSS hook), so the row is hidden here and again
     whenever the picker re-renders. The other benefit rows stay. */
  var guarCard = document.querySelector('#main .ll-pdp-guar');
  if (guarCard && getComputedStyle(guarCard).display !== 'none' && window.customElements && window.MutationObserver) {
    var hideDup = function (root) {
      root.querySelectorAll('.group-content-benefit-col-list li').forEach(function (li) {
        if (/money.?back guarantee/i.test(li.textContent) && li.style.display !== 'none') li.style.display = 'none';
      });
    };
    customElements.whenDefined('skio-plan-picker').then(function () {
      document.querySelectorAll('skio-plan-picker').forEach(function (picker) {
        var watch = function () {
          var root = picker.shadowRoot;
          if (!root) return false;
          hideDup(root);
          new MutationObserver(function () { hideDup(root); }).observe(root, { childList: true, subtree: true });
          return true;
        };
        if (!watch()) setTimeout(watch, 600);
      });
    });
  }

  /* a tap on the dimmed backdrop closes the dialog */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('ll-pdp-dialog') && e.target.open) e.target.close();
  });
})();

/* ---------- PDP rollout 10-14 (append-only; the R10 block above is untouched) ----------
   R10 ingredient cards on the other product pages. The split above handles one paragraph with a <br> (the Multi and D3 cards).
   This finishes the two other card formats, then applies the approved short lines per product page:
   - one paragraph without a <br>: "Sourced from: ... Benefits: ..." (older Multi copies);
   - two paragraphs (Pre & Probiotic, Elderberry): source line, then "Benefits: ...".
   Both become the same single paragraph the R10 CSS styles: highlighted benefit line, then the source line.
   Lines: Elderberry (Brad 10-14), Pre & Probiotic digestive lines (Brad approved 10-14; "Clinically Studied Probiotic" stays).
   Theme-only: the ingredient entries in Shopify are not changed. */
(function () {
  'use strict';
  var html = document.documentElement;
  if (!html.classList.contains('ll-pdp--v3') || !html.classList.contains('ll-chg-ingr')) return;
  var t = (html.className.match(/\bll-pdp--t-([\w-]+)/) || [])[1] || '';
  var byPage = {
    'bbv2-kids-elderberry': { 'european elderberry extract': 'Supports immune health*', 'vitamin c': 'Supports immune function*', 'zinc': 'Immune system support for kids*' },
    'bbv2-adult-elderberry': { 'european elderberry extract': 'Supports immune health*', 'vitamin c': 'Supports immune function*', 'zinc': 'Immune system support*' },
    'bbv2-kids-pre-probiotic': { 'xos prebiotic fiber': 'Supports digestive regularity*', 'bacillus coagulans': 'Supports healthy digestion*', 'bacillus subtilis': 'Supports healthy digestion*' },
    'bbv2-adult-pre-probiotic': { 'xos prebiotic fiber': 'Supports digestive regularity*', 'bacillus coagulans': 'Supports healthy digestion*', 'bacillus subtilis': 'Supports healthy digestion*' }
  };
  /* same words as the R10 map above, for cards the split above could not reach (no <br>) */
  var multi = { 'vitamin a': 'Supports immune function*', 'vitamin c': 'Supports immune health*', 'vitamin d3': 'Supports bone and immune health*',
    'vitamin k2 (mk-7)': 'Supports healthy bones*', 'thiamine (vitamin b1)': 'Supports energy metabolism*', 'riboflavin (vitamin b2)': 'Supports energy production*',
    'niacin (vitamin b3)': 'Helps the body use energy*', 'pantothenic acid (vitamin b5)': 'Helps turn food into energy*', 'vitamin b6': 'Supports the immune system*',
    'vitamin e': 'Supports antioxidant activity*', 'folate': 'Supports cell growth*', 'vitamin b12 (as methylcobalamin)': 'Supports red blood cell formation*', 'biotin': 'Supports skin, hair and nails*' };
  var page = byPage[t] || null;
  var isBen = function (s) { return /^\s*(<[^>]+>\s*)*benefits?\s*:/i.test(s); };
  document.querySelectorAll('.pdp-ingredients-redesign__card').forEach(function (c) {
    var box = c.querySelector('.pdp-ingredients-redesign__card-text');
    var title = c.querySelector('.pdp-ingredients-redesign__card-title');
    if (!box || !title) return;
    var fresh = false;
    if (!box.querySelector('.ll-ingr-ben')) {
      var ps = box.querySelectorAll('p');
      var ben = '', src = '';
      if (ps.length === 2 && (isBen(ps[0].innerHTML) || isBen(ps[1].innerHTML))) {
        var bi = isBen(ps[0].innerHTML) ? 0 : 1;
        ben = ps[bi].innerHTML.trim(); src = ps[1 - bi].innerHTML.trim();
        ps[1 - bi].remove();
        ps[bi].innerHTML = '<span class="ll-ingr-ben">' + ben + '</span><span class="ll-ingr-src">' + src + '</span>';
        fresh = true;
      } else if (ps.length === 1) {
        var m = ps[0].innerHTML.match(/^([\s\S]*?)((?:<strong>\s*)?benefits?\s*:[\s\S]*)$/i);
        if (m && /sourced?\s*(from)?\s*:/i.test(m[1])) {
          ps[0].innerHTML = '<span class="ll-ingr-ben">' + m[2].trim() + '</span><span class="ll-ingr-src">' + m[1].trim() + '</span>';
          fresh = true;
        }
      }
    }
    var b = box.querySelector('.ll-ingr-ben');
    if (!b) return;
    var k = title.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
    var line = page && (k in page) ? page[k] : (fresh && (k in multi) ? multi[k] : null);
    if (line) b.textContent = line;
  });
})();

/* ---------- Ingredient row: centre it when every card fits (Brad 10-16 "center these on PDP"; append-only, v3 pages) ----------
   Centring itself is pure CSS in ll-pdp.css (auto margins on the first and last card: they centre the row when there is spare
   room and collapse to 0 when the row overflows, so nothing moves when this script runs). This block only measures each
   visible panel (track scrollWidth vs clientWidth, same 2px slack as the section's own script) and sets .ll-ingr--fits on it,
   which hides the arrows and the progress bar with visibility (their space is kept, so no layout shift). Re-checks on resize,
   on track/card size changes, on ingredient tab clicks, on flavor chip clicks and when a panel is shown or its cards change. */
(function () {
  'use strict';
  var html = document.documentElement;
  if (!html.classList.contains('ll-pdp--v3') || !document.querySelector('.pdp-ingredients-redesign')) return;
  var check = function (panel) {
    var t = panel.querySelector('[data-ingredients-track]');
    if (!t || !t.clientWidth) return; /* hidden panel: measured when it shows */
    var fits = t.scrollWidth - t.clientWidth <= 2;
    if (panel.classList.contains('ll-ingr--fits') !== fits) panel.classList.toggle('ll-ingr--fits', fits);
    /* Kids Multi's Earnest sits over the first card: give CSS the first card's offset for when the row is centred */
    var first = t.querySelector('.pdp-ingredients-redesign__card');
    var car = panel.querySelector('.pdp-ingredients-redesign__carousel');
    if (first && car) panel.style.setProperty('--ll-ingr-start', Math.round(first.getBoundingClientRect().left - car.getBoundingClientRect().left) + 'px');
  };
  var all = function () { document.querySelectorAll('.pdp-ingredients-redesign__panel').forEach(check); };
  var queued = 0;
  var soon = function () { if (queued) return; queued = requestAnimationFrame(function () { queued = 0; all(); }); };
  all();
  window.addEventListener('resize', soon);
  window.addEventListener('load', soon);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.pdp-ingredients-redesign__tab, .pdpv2__chip')) { soon(); setTimeout(soon, 400); }
  });
  document.addEventListener('shopify:section:load', soon);
  var watch = function (sec) {
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(soon);
      sec.querySelectorAll('[data-ingredients-track], .pdp-ingredients-redesign__card').forEach(function (el) { ro.observe(el); });
    }
    if ('MutationObserver' in window) {
      new MutationObserver(soon).observe(sec, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });
    }
  };
  document.querySelectorAll('.pdp-ingredients-redesign').forEach(watch);
})();

/* Review links (Brad 10-17, "link needs to work, check all pdps"). The buy box's rating line (stars + count) scrolled to the Okendo
   widget at the very bottom of the page, past the reviews module. One anchor per page, id="reviews". Launch call 10-17: the
   count lands on the FULL reviews section at its summary (sections/ll-pdp-allreviews: five-star count + star bars + every
   review), else today's Okendo widget (sections/reviews-widget), and the top featured module (sections/ll-pdp-reviews) only
   as a last resort. Both full sections render id="reviews" server-side; this keeps it on the chosen one and clears any
   other copy. The rating line and every in-page "#reviews" link smooth-scroll there, the heading landing clear
   of the sticky header (scroll-margin-top). Capture phase, so the buy box's own scroll-to-widget listener never runs; the buy
   box file itself is untouched. */
(function () {
  'use strict';
  if (window.__llPdpRv) return;
  window.__llPdpRv = true;
  var target = document.querySelector('[data-ll-ar]') || document.querySelector('.reviews-widget') || document.querySelector('[data-ll-pdp-rev]');
  if (!target) return;
  document.querySelectorAll('[id="reviews"]').forEach(function (el) { if (el !== target) el.removeAttribute('id'); });
  target.id = 'reviews';
  target.style.scrollMarginTop = 'calc(var(--ll-hdr-h, 72px) + 12px)';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function go(smooth) {
    target.scrollIntoView({ behavior: smooth && !reduced ? 'smooth' : 'auto', block: 'start' });
    /* lazy images above can move the target while the smooth scroll runs: settle once it stops */
    var done = false;
    function settle() {
      if (done) return; done = true;
      var hdr = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ll-hdr-h')) || 72;
      var top = target.getBoundingClientRect().top;
      if (top < hdr || top > hdr + 40) target.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
    if ('onscrollend' in window) window.addEventListener('scrollend', settle, { once: true });
    setTimeout(settle, smooth && !reduced ? 1600 : 50);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-pdpv2-rating-scroll], a[href="#reviews"]') : null;
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    go(true);
  }, true);
  if (location.hash === '#reviews') {
    go(false);
    window.addEventListener('load', function () { go(false); }, { once: true });
  }
})();

/* Headline fit (Brad 10-17: the Kids Multi headline "looks cut off at the right edge"). Desktop (960px+) shows the headline on
   one line, sized by the CSS rules in ll-pdp.css to the buy-box column. Those sizes are calibrated in Chrome with the site
   fonts loaded; a wider fallback font, another browser's metrics or zoom can push the line past the column. This measures the
   line at its CSS size and, only when it does not fit, shrinks it to the column; if that would leave it under 1.12x the
   product line under it, it wraps to balanced lines instead. Pages whose CSS wraps the line get one line the same way when it
   fits above that floor. Words never change; phones keep their CSS. */
(function () {
  'use strict';
  var h = document.querySelector('html.ll-pdp--v3.ll-chg-hero #main .pdpv2bb .bbv2-valueprop');
  if (!h || !window.matchMedia) return;
  var mq = window.matchMedia('(min-width: 960px)');
  var lastW = -1;
  function fit(force) {
    var w = h.clientWidth;
    if (!force && w === lastW) return;
    lastW = w;
    h.style.removeProperty('font-size'); h.style.removeProperty('white-space'); h.style.removeProperty('text-wrap');
    h.removeAttribute('data-ll-fit');
    if (!mq.matches || !w) return;
    var base = parseFloat(getComputedStyle(h).fontSize);
    h.style.whiteSpace = 'nowrap';
    var r = document.createRange(); r.selectNodeContents(h);
    var need = r.getBoundingClientRect().width;
    if (need <= w) { h.setAttribute('data-ll-fit', 'css'); return; }
    var sub = document.querySelector('#main .pdpv2bb .pdpv2__title');
    var subFs = sub ? parseFloat(getComputedStyle(sub).fontSize) : 15;
    var floor = Math.max(subFs + 1, subFs * 1.12);   /* 1.12 = Kids Pre & Pro's accepted 1024px ratio (16.97 / 15px, 10-16) */
    var size = base;
    for (var i = 0; i < 4 && need > w && size >= floor; i++) {   /* re-measure: spacing does not always scale with size */
      size = Math.floor(size * (w / need) * 0.985 * 10) / 10;
      h.style.fontSize = size + 'px';
      need = r.getBoundingClientRect().width;
    }
    if (size >= floor && need <= w) { h.setAttribute('data-ll-fit', 'shrunk'); return; }
    h.style.removeProperty('font-size');
    h.style.whiteSpace = 'normal'; h.style.setProperty('text-wrap', 'balance'); h.setAttribute('data-ll-fit', 'wrap');
  }
  fit(true);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(true); });
  window.addEventListener('load', function () { fit(true); });
  if ('ResizeObserver' in window) new ResizeObserver(function () { fit(false); }).observe(h.closest('.pdpv2__buybox') || document.body);
  else window.addEventListener('resize', function () { fit(false); });
  if (mq.addEventListener) mq.addEventListener('change', function () { fit(true); });
})();

